<template>
  <div class="reports-wrapper">
    <div class="reports-card">
      <h2>Reports</h2>
      <form @submit.prevent class="report-form">
        <div class="form-group">
          <label for="reportType">Report Type:</label>
          <select
            id="reportType"
            v-model="selectedReport"
            class="form-control form-control-sm"
            required
          >
            <option value="">-- Select Report Type --</option>
            <option value="accountsValues">Accounts Values Report</option>
            <option value="firmCarryovers">Firm Carryovers Report</option>
            <option value="billing">AdvisorBOB Billing Report</option>
            <option value="delinkedAccounts">Delinked Accounts Report</option>
          </select>
        </div>

        <div v-if="selectedReport" class="report-content">
          <component :is="currentReportComponent"></component>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AccountsValuesReport from "./accounts-values-report.vue";
import FirmCarryoversReport from "./firm-carryovers-report.vue";
import BillingReport from "./billing-report.vue";
import DelinkedAccountsReport from "./delinked-accounts-report.vue";

export default {
  components: {
    AccountsValuesReport,
    FirmCarryoversReport,
    BillingReport,
    DelinkedAccountsReport
  },
  data() {
    return {
      selectedReport: ""
    };
  },
  computed: {
    currentReportComponent() {
      const componentMap = {
        accountsValues: "AccountsValuesReport",
        firmCarryovers: "FirmCarryoversReport",
        billing: "BillingReport",
        delinkedAccounts: "DelinkedAccountsReport"
      };
      return componentMap[this.selectedReport] || null;
    }
  }
};
</script>

<style scoped>
.reports-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 40px 20px;
  background-color: #f5f5f5;
}

.reports-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 650px;
  width: 100%;
}

.reports-card h2 {
  margin: 0 0 30px 0;
  color: #0c2b4b;
  font-size: 28px;
  text-align: center;
}

.report-form {
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
  font-size: 14px;
}

.form-control-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  height: auto;
  width: 100%;
}

.report-content {
  margin-top: 30px;
}
</style>

